var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 4.3445H6.4791V8.9697C6.4791 9.02986 6.52832 9.07907 6.58848 9.07907H7.40879C7.46895 9.07907 7.51816 9.02986 7.51816 8.9697V4.3445H8.53125C8.62285 4.3445 8.67344 4.23923 8.61738 4.16814L7.08613 2.22947C7.0759 2.21639 7.06283 2.20582 7.04791 2.19855C7.03298 2.19128 7.0166 2.1875 7 2.1875C6.9834 2.1875 6.96702 2.19128 6.95209 2.19855C6.93717 2.20582 6.9241 2.21639 6.91387 2.22947L5.38262 4.16677C5.32656 4.23923 5.37715 4.3445 5.46875 4.3445ZM12.0039 8.55954H11.1836C11.1234 8.55954 11.0742 8.60876 11.0742 8.66892V10.7744H2.92578V8.66892C2.92578 8.60876 2.87656 8.55954 2.81641 8.55954H1.99609C1.93594 8.55954 1.88672 8.60876 1.88672 8.66892V11.3759C1.88672 11.6179 2.08223 11.8134 2.32422 11.8134H11.6758C11.9178 11.8134 12.1133 11.6179 12.1133 11.3759V8.66892C12.1133 8.60876 12.0641 8.55954 12.0039 8.55954Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.226dfcf7adc6162d9c03215ded66be5a.svg";
export { ForwardRef as ReactComponent };